// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__1Tp3Q","active":"Tabs_active__1sTEN"};